var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-cont-wrap",class:{ 'h5-empty-wrap': _vm.isH5, 'electron-empty-wrap': _vm.isElectron }},[_c('div',{staticClass:"cont-wrap"},[_c('img',{attrs:{"src":_vm.emptyImgUrl,"alt":""}}),_c('span',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]),_c('button',{staticClass:"operate-btn",on:{"click":_vm.jumpHome}},[_vm._v("回到主页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }